import TapaVAV from "./TapaVAV";

export default class TapaDemo {
  constructor() {
    this.prng = this.prng.bind(this);
    this.payload = this.payload.call(this);
  }

  prng(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  payload() {
    const floors = this.prng(5, 20);
    const ahus = this.prng(1, 5);
    const vavs = this.prng(5, 20);

    const payload = {};
    for (let i = 0; i < floors; i++) {
      const payloadChildren = {};

      //Generate AHUs
      for (let a = 0; a < ahus; a++) {
        payloadChildren[`AHU ${a}`] = {
          //Assign data
          ...new TapaVAV("output")
        };
      }

      //Generate VAVs
      for (let v = 0; v < vavs; v++) {
        payloadChildren[`VAV ${v}`] = {
          //Assign data
          ...new TapaVAV("output")
        };
      }

      payload[`Floor ${i}`] = {
        data: { ...payloadChildren }
      };
    }
    return payload;
  }
}



// WEBPACK FOOTER //
// ./src/lib/TapaDemo.js